import {Injectable} from "@angular/core";
import {LogLevel} from "../data/logLevel";
import {LogSourceType} from "../data/logSourceType";
import {LogSource} from "../data/logSource";
import {LoggerService} from "./logger.service";

@Injectable({
  providedIn: 'root'
})
export class LoggerConsoleService {

  static emulateConsole: boolean = true;


  errOld = console.error;
  warnOld = console.warn;
  logOld = console.log;
  // tslint:disable-next-line:no-console
  debugOld = console.debug;

  constructor(private loggerService: LoggerService) {
    if (LoggerConsoleService.emulateConsole) {
      this.changeConsoleBehavior();
    }
  }


  changeConsoleBehavior() {
    if (!LoggerService.enabled) {
      return;
    }
    console.error = async (args) => {
      this.loggerService.logMessage(LogLevel.ERROR, LogSourceType.WEBKIT, LogSource.Console, args.toString());
      if (LoggerConsoleService.emulateConsole) {
        this.errOld.call(this, args);
      }
    };
    console.warn = (args) => {
      this.loggerService.logMessage(LogLevel.WARN, LogSourceType.WEBKIT, LogSource.Console, args.toString());
      if (LoggerConsoleService.emulateConsole) {
        this.warnOld.call(this, args);
      }
    };
    console.log = (args) => {
      this.loggerService.logMessage(LogLevel.INFO, LogSourceType.WEBKIT, LogSource.Console, args.toString());
      if (LoggerConsoleService.emulateConsole) {
        this.logOld.call(this, args);
      }
    };

  }

}
